import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5db2b4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b5db2b4c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5db2b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5db2b4c')) {
      api.createRecord('b5db2b4c', component.options)
    } else {
      api.reload('b5db2b4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b5db2b4c&scoped=true", function () {
      api.rerender('b5db2b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/TutorStandBook/components/StudentTutor/index.vue"
export default component.exports